import { ICON_TYPES } from './iconTypes';
import { COLORS } from '@bcm/constants';

export default {
	sexGenderUnknown: {
		name: 'crosshairs-question',
		type: ICON_TYPES.materialCommunityIcons,
		style: { color: COLORS.sexGender.unknown},
		text: 'Unknown'
	},
	sexGenderFemale: {
		name: 'female',
		type: ICON_TYPES.ionicon,
		style: { color: COLORS.sexGender.female},
		text: 'Female',
	},
	sexGenderMale: {
		name: 'male',
		type: ICON_TYPES.ionicon,
		style: { color: COLORS.sexGender.male},
		text: 'Male',
	},
	sexGenderTrans: {
		name: 'transgender',
		type: ICON_TYPES.ionicon,
		style: { color: COLORS.sexGender.trans},
		text: 'Transgender',
	},
	sexGenderOther: {
		name: 'male-female',
		type: ICON_TYPES.ionicon,
		style: { color: COLORS.sexGender.unkown},
		text: 'Other',
	},
};